let dialog = null;
let requestID = null;
let currLineID = "";
let wfId = null;
let curLinkId = null;
let sPid = "";
let owner = null;
let currBtn = null;
let countDown = 0;
let peopleData = [];
let defaultShowPeoples = [];
let receivers = '';
let $form = null;

export default {
  //发送
  async send(params, btn, own, _self, data) {
    const [param, showLink] = params;
    currBtn = btn;
    owner = own;
    $form = _self.$form;
    const setting = getParams(param, btn);
    const { completed } = btn;
    let lineBtns;
    // 自动签收
    if (param.sPID && _self?.autoReceive) {
      _self?.autoReceive({
        sPID: param.sPID,
        sCurLinkID: param.sCurLinkID,
      });
    }
    // 分环节发送
    if (btn.isLinkSend && !btn.line) {
      const index = _self.buttons.indexOf(btn);
      lineBtns = await _self.getFlowBtns(setting.param, btn, _self.buttons, index);
      if (dsf.isString(lineBtns)) {
        btn.disabled = false;
        dsf.layer.message(lineBtns, false);
        return;
      }
      if (showLink) {
        // 自定义显示隐藏按钮
        own.$vm?.[showLink](lineBtns, data);
      }
      lineBtns?.forEach((item) => (item.disabled = false));
      if (lineBtns?.length > 1) {
        return;
      }
    }
    dsf.http
      .post(setting.url, setting.param)
      .done((res) => {
        handler(res, false, completed);
      })
      .catch((res) => {
        dsf.error(res);
        dsf.layer.message("发送异常", false);
        requestID = null;
      })
      .finally(() => {
        // 防止网络请求很快的情况
        setTimeout(() => {
          btn.disabled = false;
        }, 1000);
      });
  },
  // 退回
  sendBack(params, btn, own, _self) {
    if (btn.disabled) {
      return;
    }
    btn.disabled = true;
    owner = own;
    $form = _self.$form;
    let param = {
      sPID: params[0] || null,
      sCurLinkID: params[1] || null,
    };
    dsf.http
      .post("wfr/getSendBackLink", param)
      .done((res) => {
        if (res?.data?.BackLinks) {
          let BackLinks = res.data.BackLinks;
          if (BackLinks.length == 1) {
            dsf.global.$isMobile ? mobileSendBack(params, BackLinks[0].ID) : sendBack(params, BackLinks[0].ID);
          } else {
            chooseBackNode(BackLinks, params);
          }
        } else {
          dsf.layer.message(res.data.Message || "退回异常", false);
        }
      })
      .catch((res) => {
        dsf.error(res);
        dsf.layer.message("退回异常", false);
      })
      .finally(() => {
        // 防止网络请求很快的情况
        setTimeout(() => {
          btn.disabled = false;
        }, 200);
      });
  },
  // 销毁
  destroy(args) {
    if (args.targetButton.disabled) {
      return;
    }
    owner = args.owner;
    $form = args._self.$form;
    let [sPID] = args.params;
    const param = {
      sPID: sPID || dsf.url.queryString("sPID"),
    };
    args.targetButton.disabled = true;
    dsf.http
      .post("wfr/destroy", param)
      .then((res) => {
        if (res.data.success) {
          if (res.data?.data?.Code === 20006) {
            args.owner.$dispatch("destroy", res.data);
            args._self?.$form?.$viewDataReset?.();
            closeOpener();
            dsf.layer.message("操作成功", true);
          } else {
            dsf.layer.message(res.data.data.Message || "操作失败", false);
          }
        } else {
          dsf.layer.message(res.data.message, false);
        }
      })
      .finally(() => {
        // 防止网络请求很快的情况
        setTimeout(() => {
          args.targetButton.disabled = false;
        }, 200);
      });
  },
  // 回收 强制回收 强制办结
  recovery(args) {
    if (args.targetButton.disabled) {
      return;
    }
    owner = args.owner;
    $form = args._self.$form;
    let [sPID, sCurLinkID] = args.params;
    // 兼容以前写法
    if (sPID?.indexOf(".") > -1) {
      sPID = args.data[sPID];
    }
    if (sCurLinkID?.indexOf(".") > -1) {
      sCurLinkID = args.data[sCurLinkID];
    }
    const param = {
      sPID: sPID || dsf.url.queryString("sPID"),
      sCurLinkID: sCurLinkID || dsf.url.queryString("sCurLinkID"),
    };
    if (args.targetButton.actionName === "system_flow_forceRecovery") {
      param.bForce = true;
    }
    args.targetButton.disabled = true;
    const url = args.targetButton.actionName === "system_flow_forceClose" ? "wfr/forceClose" : "wfr/recovery";
    dsf.http
      .post(url, param)
      .then((res) => {
        if (res.data.state == 20000) {
          if (
            res.data.data &&
            (res.data.data.Code === 20000 || res.data.data.Code === 22000 || res.data.data.Code === 20006 || res.data.data.Code === 20007)
          ) {
            args.owner.$dispatch("recovery", res.data);
            args._self?.$form?.$viewDataReset?.();
            closeOpener()
            dsf.layer.message("操作成功", true);
          } else {
            dsf.layer.message(res.data.data.Message || "操作失败", false);
          }
        } else {
          dsf.layer.message(res.data.message, false);
        }
      })
      .finally(() => {
        // 防止网络请求很快的情况
        setTimeout(() => {
          args.targetButton.disabled = false;
        }, 200);
      });
  },
  // 流转情况
  situation(args) {
    let [isDialog, sPID] = args.params;
    // 固定地址 不给修改
    let url = `/dsfa/flow/processinfo?sPID=${sPID || dsf.url.queryString("sPID")}`;
    args.targetButton.disabled = true;
    if (isDialog) {
      dsf.layer.openDialog({
        title: "",
        width: "90vw",
        height: "80vh",
        params: {
          path: dsf.url.getWebPath(url),
        },
        btns: [],
      });
    } else {
      url = `/page.html#/pc${url}`;
      dsf.layer.openWindow(url);
    }
    setTimeout(() => {
      args.targetButton.disabled = false;
    }, 200);
  },
  // 更换处理人
  changeHandler(args) {
    owner = args.owner;
    $form = args._self.$form;
    dsf.layer.openDialog({
      title: "请选择办理人",
      width: "500px",
      height: "420px",
      overflow: "hidden",
      content: "DsfFlowSelectTree",
      params: {
        lazy: true,
        loadNode: loadPeople,
        defaultKeys: defaultShowPeoples,
        showSearch: true,
      },
      btns: [
        {
          text: "确定",
          handler: (component) => {
            const checked = component?.$refs?.treeForm?.getCheckedNodes() || [];
            if (checked?.length === 0) {
              dsf.layer.message("请选择一个办理人", false);
              return false;
            }
            let [sPID, sCurLinkID] = args.params;
            // 兼容以前写法
            if (sPID?.indexOf(".") > -1) {
              sPID = args.data[sPID];
            }
            if (sCurLinkID?.indexOf(".") > -1) {
              sCurLinkID = args.data[sCurLinkID];
            }
            let param = {
              sPID: sPID || dsf.url.queryString("sPID"),
              sCurLinkID: sCurLinkID || dsf.url.queryString("sCurLinkID"),
              userId: checked[0]?.id,
            };
            return dsf.http.post("/wfr/changeHandler", param).done((res) => {
              handler(res);
              return Promise.resolve();
            });
          },
        },
        {
          text: "取消",
        },
      ],
    });
    setTimeout(() => {
      args.targetButton.disabled = false;
    }, 200);
  },
  // 填写处理意见
  addComment(args) {
    if (args.targetButton.disabled) {
      return;
    }
    let [sPID, sCurLinkID] = args.params;
    args.targetButton.disabled = true;
    dsf.layer.openDialog({
      title: "处理意见",
      width: dsf.global.$isMobile ? "100vw" : "800px",
      height: dsf.global.$isMobile ? "100vw" : "490px",
      content: dsf.global.$isMobile ? "DsfMobileFlowAddComment" : "DsfFlowAddComment",
      hasFooter: false,
      footerAlign: "center",
      params: {
        $vm: args._self.$vm,
        flow: {
          sPID: sPID || args.owner?.sPID || null,
          sCurLinkID: sCurLinkID || args.owner?.sCurLinkID || null
        }
      },
      dialogArgs: {},
      btns: []
    });
    // 防止网络请求很快的情况
    setTimeout(() => {
      args.targetButton.disabled = false;
    }, 200);
  },
};
// 选择自由流
function chooseFreedom(data) {
  let lines = data.SendParams.Lines;
  let line = lines.length > 1 ? lines.filter((c) => c.LineID == currLineID)?.[0] : lines[0];
  if (!line) {
    return;
  }
  let btns = [
    {
      text: "确定",
      handler: (component) => {
        if (component.$refs.view.validate()) {
          const loadingIndex = dsf.layer.loading();
          const result = component.$refs.view.yes();
          receivers = result.sReceivers;
          sendToReceivers(result.sReceivers, requestID, '', loadingIndex);
          return true;
        }
        return false;
      },
    },
  ];
  if (dsf.global.$isMobile) {
    btns.unshift({
      text: "取消",
    });
  }
  dsf.layer.openDialog({
    showClose: !dsf.global.$isMobile,
    fullscreen: dsf.global.$isMobile,
    title: "选择发送对象",
    width: dsf.global.$isMobile ? "100vw" : "1050px",
    height: dsf.global.$isMobile ? "100vh" : "calc(85vh - 120px)",
    btnPosition: "bottom",
    params: {
      wfId: wfId,
      line: line,
      curLinkId: curLinkId,
      path: dsf.global.$isMobile ? "#/mobile/dsfa/flow/freedom/mobile-index" : "/dsfa/flow/freedom/index",
    },
    btns: btns,
  });
}
function directlySend(data, completed) {
  let list = [];
  if (data.Code == 20000 || data.Code == 20001 || data.Code == 20003) {
    data.Links.forEach((line, index) => {
      if ((line.Status == 0 || line.Status == -2) && line.LinkUser) {
        let linkUser = line.LinkUser;
        let type = line.LinkUser.Type;
        if (type == 1) {
          // 直接选人
          list.push(linkUser.UserName);
        } else if (type == 2) {
          let DeptName = linkUser.DeptName;
          // 部门+角色
          list.push(`${DeptName}-${linkUser.RoleName}`);
        } else if (type == 3) {
          // 岗位
          list.push(linkUser.JobName);
        } else if (type == 4) {
          // 人+关系
          list.push(`${linkUser.UserName}-${linkUser.RelationName}`);
        } else if (type == 5) {
          // 机器人
          list.push(linkUser.RobotName);
        }
      }
    });
    dsf.layer.openDialog({
      type: "dialog",
      title: "流程已发送到以下人员：",
      width: "320px",
      height: "auto",
      overflow: "auto",
      content: "SendFlowDialog",
      footerAlign: "center",
      showClose: false,
      params: {
        list: _.uniq(list),
        countDownTime: countDown,
      },
      btns: [
        {
          text: "确定",
          class: `sendFlow ${dsf.global.$isMobile ? "van-dialog__confirm" : ""}`,
          handler: (component) => {
            closeOpener();
            return true;
          },
        },
      ],
    });
  } else {
    let msg = "发送成功",
      code = data.Code;
    switch (code) {
    case 20004:
    case 20005:
      msg = completed ? owner.$replace(completed, owner.$expressParams(data)) : "文件已办结";
      break;
    }
    dsf.layer.openDialog({
      type: "dialog",
      title: "提示",
      width: "300px",
      height: "120px",
      content: "SendFlowDialog",
      footerAlign: "center",
      showClose: false,
      params: {
        msg: msg,
        countDownTime: countDown,
      },
      btns: [
        {
          text: "确定",
          class: `sendFlow ${dsf.global.$isMobile ? "van-dialog__confirm" : ""}`,
          handler: () => {
            closeOpener();
            return true;
          },
        },
      ],
    });
  }
}
function chooseSendNode(data) {
  let btns = [];
  if (data.SendParams?.Lines?.[0]?.SendToLineID) {
    btns.push({
      text: "返回",
      class: "plain",
      handler: () => {
        let param = {
          sRequestID: requestID,
          sLineID: data.SendParams.Lines[0]?.BackLineID,
        };
        dsf.http.post("wfr/setLineToBack", param).done((res) => {
          handler(res);
        });
        return true;
      },
    });
  }
  dialog = dsf.layer.openDialog({
    title: "请选择要发送的环节：",
    width: "400px",
    height: "auto",
    overflow: "auto",
    footerAlign: "center",
    content: "ChooseSendNode",
    params: {
      lines: data.SendParams.Lines,
      callback: (res, isShowBack, line) => {
        currLineID = line.LineID;
        handler(res.data, isShowBack);
      },
      requestID: requestID,
      type: "next",
    },
    btns: btns,
  });
}
function mobileChooseSendNode(data) {
  const showBack = data.SendParams.Lines && data.SendParams.Lines[0] && data.SendParams.Lines[0].SendToLineID ? true : false;
  const BackLineID = showBack ? data.SendParams.Lines[0].SendToLineID : "";
  const height = data.SendParams.Lines.length * 50 + 62 + (showBack ? 44 : 0);
  dialog = dsf.layer.openDialog({
    height: height + "px",
    hasHeader: false,
    hasFooter: false,
    content: "DsfMobileChooseSendNode",
    params: {
      requestID: requestID,
      lines: data.SendParams.Lines,
      title: "请选择要发送的环节：",
      callback: (res, isShowBack, line) => {
        currLineID = line.LineID;
        handler(res.data, isShowBack);
      },
      showBack: showBack,
      back: () => {
        back(BackLineID);
      },
    },
    btns: [],
  });
}
function back(BackLineID) {
  let param = {
    sRequestID: requestID,
    sLineID: BackLineID,
  };
  dsf.http.post("wfr/setLineToBack", param).done((res) => {
    if (res.state == 20000) {
      handler(res);
    }
  });
}

function chooseSendTree(data, isShowBack) {
  let lines = data.SendParams.Lines;
  const LineID = lines.map((c) => c.LineID).join();
  dialog = dsf.layer.openDialog({
    title: "请选择办理人",
    width: "900px",
    height: "420px",
    overflow: "hidden",
    content: "ChooseSendTree",
    params: {
      lines: lines,
    },
    btns: [
      {
        text: "返回",
        type: "plain",
        class: `choose-send-node ${isShowBack ? "" : "hide"}`,
        handler: (component) => {
          let param = {
            sRequestID: requestID,
            sLineID: data.SendParams?.Lines?.[0].SendToLineID,
          };
          dsf.http.post("wfr/setLineToBack", param).done((res) => {
            handler(res);
          });
          return true;
        },
      },
      {
        text: "选择模板",
        class: dsf.global.$isMobile ? "hide" : "",
        handler: (component) => {
          let param = {
            sLineIDs: LineID,
          };
          dsf.http.post("wfr/getHandlerTemplateList", param).done((res) => {
            if (res.success) {
              const data = res.data;
              data.forEach((item) => {
                item.id = item.dsfa_wf_link_handler_template;
                item.label = item.template_name;
              });
              dsf.layer.openDialog({
                title: "选择模板",
                width: "330px",
                height: "420px",
                overflow: "hidden",
                content: "DsfFlowSelectTree",
                params: {
                  treeData: data,
                  showDel: true,
                  delUrl: "wfr/delHandlerTemplate",
                },
                btns: [
                  {
                    text: "确定",
                    handler: (com) => {
                      let nodes = com.$refs.treeForm.getCheckedNodes();
                      nodes = nodes.filter((node) => !node.disabled);
                      let ids = [];
                      for (const node of nodes) {
                        let receivers = node.receiver.split(";");
                        for (const receiver of receivers) {
                          ids.push(...receiver.replace(/.*\:/, "").split(","));
                          const rec = receiver.split(":");
                          const LineID = rec[0];
                          for (const line of component.linesData) {
                            if (line.LineID === LineID) {
                              line.checked = rec[1].split(",");
                            }
                          }
                        }
                      }
                      return true;
                    },
                  },
                ],
              });
            }
          });
          return false;
        },
      },
      {
        text: "保存模板",
        class: dsf.global.$isMobile ? "hide" : "",
        handler: (component) => {
          if (component.validate()) {
            dsf.layer
              .prompt({
                message: "模板名称",
                inputPlaceholder: "请输入模板名称",
                inputType: "input",
                inputPattern: /\S/,
                inputErrorMessage: "模板名称不能为空",
                confirmButtonText: "确定",
                inputValidator: (input) => {
                  if (input && input.length > 50) {
                    return "模板名称长度不能超过50";
                  }
                  return true;
                },
              })
              .then(({ value }) => {
                const result = component.yes();
                let param = {
                  templateName: value,
                  sLineIDs: LineID,
                  sReceivers: result,
                };
                dsf.http.post("wfr/saveHandlerTemplate", param).done((res) => {
                  if (res.success) {
                    dsf.layer.message("保存成功", true);
                  } else {
                    dsf.layer.message(res.message, false);
                  }
                });
              });
            return false;
          }
          return false;
        },
      },
      {
        text: "确定",
        type: "",
        handler: (component) => {
          if (component.validate()) {
            const result = component.yes();
            sendToReceivers(result, requestID);
            document.querySelector(".close-send-node")?.click();
            return true;
          }
          return false;
        },
      },
    ],
  });
}

function mobileChooseSendTree(data, isShowBack) {
  dialog = dsf.layer.openDialog({
    showClose: false,
    title: "请选择办理人",
    fullscreen: true,
    width: "100vw",
    height: "100vh",
    class: "work_flow-usersDialog",
    content: "DsfMobileChooseUsers",
    btnPosition: "bottom",
    hasFooter: true,
    params: {
      lines: data.SendParams.Lines,
      RequiredOpinion: data.SendParams.RequiredOpinion,
    },
    btns: [
      {
        text: "取消",
      },
      {
        text: "返回",
        class: `choose-send-node ${isShowBack ? "" : "hide"}`,
        handler: (component) => {
          let param = {
            sRequestID: requestID,
            sLineID: data.SendParams?.Lines?.[0]?.SendToLineID,
          };
          dsf.http.post("wfr/setLineToBack", param).done((res) => {
            if (res.state == 20000) {
              handler(res);
            }
          });
          return true;
        },
      },
      {
        text: "确定",
        handler: (component) => {
          if (component.validate()) {
            const result = component.yes();
            let param = {
              sRequestID: requestID,
              sReceivers: result.sReceivers,
            };
            if (result.disposeIdea) {
              let disposeIdea = result.disposeIdea;
              // 发送时有处理意见
              const sOpinion = {
                Content: disposeIdea.inputValue,
                Attachments: disposeIdea.multipleFiles,
              };
              param.sOpinion = JSON.stringify(sOpinion);
            }
            dsf.http.post("wfr/sendToReceivers", param).done((res) => {
              if (res.state == 20000) {
                handler(res);
              }
            });
            return true;
          }
          return false;
        },
      },
    ],
  });
}
function handler(res, isShowBack, completed) {
  if (dialog) {
    dialog.close();
    dialog = null;
  }
  if (res.success) {
    let data = res.data;
    requestID = data.RequestID;
    if (data.Code == 20000 || data.Code == 20001 || data.Code == 20003 || data.Code == 20004 || data.Code == 20005) {
      // 发送成功 || 发送到汇总节点 || 发送到汇总环节并激活汇总环节 || 办结当前节点 || 办结当前节点，并办结整个流程
      if (currBtn.flowSendOverEvent) {
        owner.$dispatch(currBtn.flowSendOverEvent, data);
      } else {
        directlySend(data, completed);
      }
    } else if (data.Code == 81000) {
      // 或选择
      dsf.global.$isMobile ? mobileChooseSendNode(data) : chooseSendNode(data);
    } else if (data.Code == 82000) {
      // 与选择
      dsf.global.$isMobile ? mobileChooseSendTree(data, isShowBack) : chooseSendTree(data, isShowBack);
    } else if (data.Code == 82001) {
      // 自由流
      chooseFreedom(data);
    } else if (data.Code == 83000) {
      // 密级可以继续发送
      security(data, true);
    } else if (data.Code == 97000) {
      // 密级不可以继续发送
      security(data, false);
    } else {
      let msg = data.Message;
      if (data.EsMessage) {
        msg = msg + "." + data.EsMessage;
      }
      dsf.layer.message(msg || "未知流程类型发送", false);
    }
  } else {
    let data = res.data;
    requestID = null;
    let msg = data?.Message || res.message;
    if (res.EsMessage) {
      msg = msg + "." + res.EsMessage;
    }
    dsf.layer.message(msg || "发送异常", false);
  }
}
function getParams(args, btn) {
  const { sWFID, sObjectID, sObjectName, sPID, sCurLinkID, sCurNodeID, sExInfos, sReceivers, sOpinion, sLineIDs, countDownTime, ds_security_level } = args;
  const { line, IsSPSend } = btn;
  let url = IsSPSend ? "wfr/startSPSend" : "wfr/startSend";
  let param = {
    sWFID: sWFID,
    sObjectID: sObjectID,
    sObjectName: sObjectName || "",
    sCurNodeID: sCurNodeID || "",
    sExInfos: dsf.isObject(sExInfos) ? JSON.stringify(sExInfos) : sExInfos,
    sReceivers: sReceivers,
    securityClassValue: ds_security_level?.value,
    securityLevelExpiryDate: ds_security_level?.expirydate
  };
  //继续发送
  if (sPID) {
    url = IsSPSend ? "wfr/spSend" : "wfr/send";
    param = {
      sPID: sPID,
      sCurLinkID: sCurLinkID,
      sExInfos: dsf.isObject(sExInfos) ? JSON.stringify(sExInfos) : sExInfos,
      sReceivers: sReceivers,
      securityClassValue: ds_security_level?.value,
      securityLevelExpiryDate: ds_security_level?.expirydate
    };
  }
  if (sOpinion) {
    param.sOpinion = sOpinion;
  }
  if (sLineIDs) {
    param.sLineIDs = sLineIDs;
  } else {
    if (line) {
      param.sLineIDs = line.LineID;
    }
  }
  wfId = param.sWFID;
  currLineID = param.sLineIDs;
  curLinkId = param.sCurLinkID;
  sPid = param.sPID;
  countDown = countDownTime || 3;
  return {
    param: param,
    url: url,
  };
}

function sendBack(args, id) {
  dsf.layer
    .prompt({
      message: "退回原因",
      inputPlaceholder: "请输入退回原因",
      inputType: "textarea",
      inputPattern: /\S/,
      inputErrorMessage: "退回原因不能为空",
      confirmButtonText: "确定",
      inputValidator: (input) => {
        if (input && input.length >= 1000) {
          return "退回意见长度不能超过1000";
        }
        return true;
      },
    })
    .then(({ value }) => {
      let param = {
        sPID: args[0] || null,
        sCurLinkID: args[1] || null,
        sReason: value || null,
        sBackLinkID: id,
      };
      dsf.http
        .post("wfr/sendBack", param)
        .done((res) => {
          if (res?.data?.Code == "21000") {
            owner.$dispatch("sendBack", res.data);
            dsf.layer.message("退回成功", true);
            closeOpener();
          } else {
            dsf.layer.message(res.data.Message || "退回异常", false);
          }
        })
        .catch((res) => {
          dsf.layer.message("退回异常", false);
        });
    });
}

function mobileSendBack(args, id) {
  dsf.layer.openDialog({
    showClose: false,
    title: "退回理由",
    fullscreen: true,
    width: "100vw",
    height: "100vh",
    template: `
      <van-field
        ref="back"
        v-model="params.value"
        rows="2"
        type="textarea"
        placeholder="请输入退回理由"
      />`,
    btnPosition: "bottom",
    params: {
      value: "",
    },
    btns: [
      {
        text: "取消",
      },
      {
        text: "确认退回",
        handler: (component, refs) => {
          if (!refs.back.value) {
            dsf.layer.message("请输入退回理由", false);
            return false;
          }
          let param = {
            sPID: args[0] || null,
            sCurLinkID: args[1] || null,
            sReason: refs.back.value || null,
            sBackLinkID: id,
          };
          return dsf.http
            .post("wfr/sendBack", param)
            .done((res) => {
              if (res?.data?.Code == "21000") {
                owner.$dispatch("sendBack", res.data);
                dsf.layer.message("退回成功", true);
                closeOpener();
              } else {
                dsf.layer.message(res.data.Message || "退回异常", false);
              }
            })
            .catch((res) => {
              dsf.layer.message("退回异常", false);
            });
        },
      },
    ],
  });
}
// 选择退回节点
function chooseBackNode(data, args) {
  const chooseNode = dsf.global.$isMobile ? (line)=> {
    sendBack([line.PID, args[1]], line.ID)
  } : dsf.noop;
  const hideHeader = dsf.global.$isMobile;
  dsf.layer.openDialog({
    type: "dialog",
    title: "请选择要退回的环节：",
    width: "300px",
    height: "auto",
    overflow: "auto",
    footerAlign: "center",
    content: (dsf.global.$isMobile ? "DsfMobile" : "") + "ChooseSendNode",
    params: {
      lines: data,
      chooseNode: chooseNode,
      hideHeader: hideHeader,
      callback: (arr, id) => { sendBack([arr[0], args[1]], id) },
      requestID: requestID,
      type: "back",
    },
    btns: [
      {
        class: `close-send-node ${dsf.global.$isMobile ? "van-dialog__cancel" : ""}`,
        text: "取消",
        handler: () => {
          dialog = null;
          return true;
        },
      },
    ],
  });
}
function loadPeople(node, resolve) {
  if (node?.level === 0) {
    initAssignDataForPeople(node, resolve);
  } else if (node?.data?.children && node?.level === 1) {
    resolve(peopleData[0].children);
  } else if (node?.data?._type != "1" && (node?.data?.UserCount > 0 || node?.data?.DeptCount > 0)) {
    initAssignDataForPeople(node, resolve, node.data.id);
  } else {
    resolve([]);
  }
}
function initAssignDataForPeople(node, resolve, fId) {
  dsf.http.get("oua/getUserByCurUnit", { sFID: fId, isAsy: true }).then((res) => {
    if (res?.data?.success) {
      let data = formatData(res.data.data, "1", "user");
      if (!fId) {
        defaultShowPeoples.push(data.id);
        peopleData = [data];
        data = [data];
      } else {
        data = data.children;
      }
      if (resolve) {
        return resolve?.(data);
      }
    }
  });
}
function formatData(data, disabledVaule, sort) {
  data.label = data.NAME || data._name;
  data.id = data.id || data._id;
  data.type = data.TYPE || data._type;
  // data.leaf = true;
  if (disabledVaule) {
    data.disabled = data.type == disabledVaule ? false : true;
  }
  if (sort) {
    if ((sort === "dept" && data.DeptCount == 0) || (sort === "user" && (data.type === 1 || (data.DeptCount == 0 && data.UserCount == 0)))) {
      data.leaf = true;
    }
  }
  data.attributes = {
    NAME: data.label,
    id: data.id,
    FID: data.pid,
    type: data.type,
  };
  delete data.NAME;
  delete data.Atts;
  delete data.TYPE;
  delete data.FID;
  if (data?.children?.length > 0) {
    for (var i = 0; i < data.children.length; i++) {
      formatData(data.children[i], disabledVaule, sort);
    }
  }
  return data;
}
function security(data, isSend) {
  let length = data?.warnUserNames?.length;
  let warnUserNames = data?.warnUserNames?.join("、");
  if (length > 20) {
    warnUserNames = data.warnUserNames.splice(0, 20).join("、");
  }
  dsf.layer.openDialog({
    title: "<div class='flow-security-title'><i class='el-alert__icon el-icon-warning'></i><span>提示</span></div>",
    width: "440px",
    height: "auto",
    customClass: 'flow-security',
    template: `<div>
      <span class="user">${warnUserNames || ''}</span>
      <span>${length > 20 ? '等' + length : ''}用户密级过低，不能处理此任务${isSend ?'，是否继续发送？': ''}</span>
    </div>`,
    btns: [
      {
        text: "仍发送",
        class: { "ds-hide": !isSend },
        handler: (component) => {
          let result = [];
          let Lines = data.SendParams.Lines;
          Lines = Lines.filter(item => item.Selected);
          Lines.forEach(line => {
            line?.Receivers?.Dept?.Objs?.forEach(obj => {
              result.push(`${line.LineID}:${obj.ID}`);
            });
          });
          sendToReceivers(receivers || result.join(";"), data.RequestID, 1);
          receivers = null;
          return true;
        },
      },
      {
        text: "取消",
      },
    ],
  });
}
function sendToReceivers(result, requestID, ignore, loadingIndex) {
  let param = {
    sRequestID: requestID,
    sReceivers: result,
    ignoreWarn: ignore
  };
  dsf.http.post("wfr/sendToReceivers", param).done((res) => {
    handler(res);
    if (dsf.isDef(loadingIndex)) {
      dsf.layer.closeLoading(loadingIndex);
    }
  });
}
function closeOpener() {
  if ($form) {
    if (dsf.global.$isMobile) {
      if (window.sendFlowTimer) {
        clearTimeout(window.sendFlowTimer);
        delete window.sendFlowTimer;
      }
      owner.$router.go(-1);
      return true;
    }
    if (owner?.$vm?.$dialog) {
      owner.$vm.$dialog?.openerVm?.reloadData?.(true);
      owner.$vm.$dialog?.close?.();
    } else if (owner?.$vm?.$openerVm) {
      owner.$vm.$openerVm?.reloadData?.(true);
      owner.$vm?.$closeWindow?.();
    } else if (window?.opener) {
      try {
        window.opener.reloadData?.(true);
      } catch (e) {
        /* ignore */
      }
      window.close();
    } else {
      owner?.reloadData?.();
      dsf.layer.closeWindow();
    }
    owner = null;
  } else {
    // 列表中
    if (owner?.$vm?.$dialog) {
      owner.$vm.$dialog?.openerVm?.reloadData?.(true);
    } else if (owner?.$vm?.$openerVm?.reloadData) {
      owner.$vm.$openerVm?.reloadData?.(true);
    } else if (window?.opener?.reloadData) {
      try {
        window.opener.reloadData?.(true);
      } catch (e) {
        /* ignore */
      }
    } else {
      owner?.reloadData?.();
    }
    owner = null;
  }
}
